<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :title="title"
    :width="width"
    append-to-body
  >
    <div class="dialog-content">
      <slot></slot>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelHandler" size="small">{{ cancelBtnText }}</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">{{
          confirmBtnText
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'IElDialog',
    props: {
      // 标题
      title: {
        type: String,
        default: '',
      },
      width: {
        type: String,
        default: '50%',
      },
      cancelBtnText: {
        type: String,
        default: '取消',
      },
      confirmBtnText: {
        type: String,
        default: '确定',
      },
    },
    data() {
      return {
        dialogVisible: false,
      };
    },
    methods: {
      openDialog() {
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
        this.$emit('cancel');
      },
      confirmHandler() {
        this.dialogVisible = false;
        this.$emit('confirm');
      },
    },
  };
</script>

<style scoped lang="scss"></style>
